import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Sun, Sparkles, Trophy } from 'lucide-react';
export function JourneyTimeline() {
  const timeline = [{
    time: 'Day 1–3',
    title: 'You start feeling lighter.',
    desc: 'Less heaviness. Less "stuck" feeling.',
    icon: <Sun className="w-6 h-6" data-id="element-156" />
  }, {
    time: 'Day 5',
    title: 'Mornings feel different.',
    desc: 'Less puffiness. More comfort.',
    icon: <Sparkles className="w-6 h-6" data-id="element-157" />
  }, {
    time: 'Week 2',
    title: 'Clothes fit better.',
    desc: 'Energy feels smoother. Confidence rises.',
    icon: <Calendar className="w-6 h-6" data-id="element-158" />
  }, {
    time: 'Month 1',
    title: 'Your new normal:',
    desc: 'Light, balanced, and in control again.',
    icon: <Trophy className="w-6 h-6" data-id="element-159" />
  }];
  return <section className="py-24 bg-white" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-161">
        <div className="text-center mb-16" data-id="element-162">
          <span className="text-[#10B981] font-bold uppercase tracking-wider text-sm" data-id="element-163">
            TRANSFORMATION TIMELINE
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-[#1B5E20] mt-4" data-id="element-164">
            Your 5-Day Reset Timeline
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-165">
          {timeline.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-[#F0FFF4] p-8 rounded-3xl border-2 border-[#10B981]/10 hover:border-[#10B981] transition-colors group" data-id="element-166">
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center text-[#10B981] shadow-sm mb-6 group-hover:bg-[#10B981] group-hover:text-white transition-colors" data-id="element-167">
                {item.icon}
              </div>
              <div className="text-[#10B981] font-bold text-sm uppercase tracking-wide mb-2" data-id="element-168">
                {item.time}
              </div>
              <h3 className="text-xl font-bold text-[#1B5E20] mb-2" data-id="element-169">
                {item.title}
              </h3>
              <p className="text-[#374151]" data-id="element-170">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}